
import React from 'react';
import { LocalCharacterInitializer } from '../../../../../../entities/characters/Character';
import { ModSlotPreview } from './mods/ModSlotPreview';
import { ItemInitializer } from '../../../../../../entities/library/items/ItemInitializers';
import { OwnedItemReference, OwnedModReference } from '../../../../../../entities/Ownership';
import { ModSlot } from '../../../../../../entities/library/items/mods/ModSlot';

type Props = {
    character?: LocalCharacterInitializer;
    reference?: OwnedItemReference;
    item: ItemInitializer;
    editable?: boolean;
}

export const ItemPreviewSlots: React.FC<Props> = (props: Props) => {6
    return (
        <>
            <div className="row sheet-slots">
                {GetSheetSlots({ ...props })}
            </div>
        </>
    );
}

export const GetSheetSlots = (props: Props): React.ReactNode[] => {
    const { character, reference, item, editable } = props;

    let mods: OwnedModReference[] = [];
    let customSlots: ModSlot[] = [];

    if (reference != null) { //There are mods
        mods = character?.activeMods.filter(m => m.assignedItemId == reference.instanceId) ?? [];
        customSlots = reference.customSlots;
    }

    return [
        ...item.slots.map(slot => (
            <ModSlotPreview key={slot.id}
                character={character}
                reference={reference}
                slot={slot}
                editable={editable} />
        )),
        ...customSlots.map(slot => (
            <ModSlotPreview key={slot.id}
                character={character}
                reference={reference}
                slot={slot}
                editable={editable}
                custom />
        ))
    ]
}